'use client'

import * as React from 'react'
import Link from 'next/link'
import { useCategories } from '@/lib/hooks/use-categories'

const linkBase =
  'px-3 py-4 text-[16px] font-allround font-medium text-[#7D744F] transition-colors duration-200 hover:text-kuma-verde'

const dropdownItem =
  'block px-3 py-2 text-[15px] font-allround text-[#7D744F] \
   hover:text-kuma-verde hover:bg-gray-50 \
   visited:text-[#7D744F] active:text-kuma-verde focus:text-kuma-verde \
   no-underline rounded-lg transition-all'

const BEBE_ITEMS = [
  { slug: 'de-0-a-3-meses', label: '0 a 3 meses' },
  { slug: 'de-3-a-6-meses', label: '3 a 6 meses' },
  { slug: 'de-6-a-12-meses', label: '6 a 12 meses' },
]

const NINOS_ITEMS = [
  { slug: 'de-12-a-18-meses', label: '1 año' },
  { slug: 'de-2-a-3-anos', label: '2 años' },
  { slug: 'de-3-a-6-anos', label: '3 a 6 años' },
]

function buildNavItems(
  items: { slug: string; label: string }[],
  categories: { id: string; slug: string }[]
) {
  return items
    .map(item => {
      const cat = categories.find(c => c.slug === item.slug)
      return cat ? { id: cat.id, slug: item.slug, label: item.label } : null
    })
    .filter((x): x is { id: string; slug: string; label: string } => x !== null)
}

export function MainNav() {
  const { categories } = useCategories()

  const [open, setOpen] = React.useState(false)
  const [isClient, setIsClient] = React.useState(false)
  const closeTimeout = React.useRef<NodeJS.Timeout | null>(null)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  const handleEnter = () => {
    if (closeTimeout.current) clearTimeout(closeTimeout.current)
    setOpen(true)
  }

  const handleLeave = () => {
    closeTimeout.current = setTimeout(() => {
      setOpen(false)
    }, 120)
  }

  const grupos = {
    bebes: buildNavItems(BEBE_ITEMS, categories),
    ninos: buildNavItems(NINOS_ITEMS, categories),
  }

  const dropdownClass = isClient
    ? open
      ? 'opacity-100 visible translate-y-0 pointer-events-auto'
      : 'opacity-0 invisible -translate-y-2 pointer-events-none'
    : 'opacity-0 invisible pointer-events-none'

  return (
    <nav className='hidden lg:block'>
      <div className='container mx-auto'>
        <ul className='flex items-center justify-center space-x-6'>
          {/* MEGA MENU */}
          <li
            className='relative'
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
          >
            <span className={`${linkBase} cursor-pointer`}>Edades</span>

            <div
              className={`
                fixed left-0 top-[104px] w-full z-50
                transition-all duration-150 ease-out
                ${dropdownClass}
              `}
            >
              <div
                className='
                  bg-white
                  shadow-[0px_10px_35px_rgba(0,0,0,0.08)]
                  border-b border-gray-200
                  rounded-b-3xl
                  py-10
                '
              >
                <div className='max-w-5xl mx-auto grid grid-cols-3 gap-16 text-center'>
                  {/* 🔹 TODOS LOS MATERIALES */}
                  <div className='flex items-center justify-center h-full'>
                    <Link href='/productos' className={dropdownItem}>
                      Ver todos los materiales
                    </Link>
                  </div>

                  {/* 🍼 BEBÉ */}
                  <div>
                    <h4 className='text-[17px] font-allround font-semibold text-[#7D744F] mb-4'>
                      Bebé
                    </h4>

                    {grupos.bebes.map(item => (
                      <Link
                        key={item.id}
                        href={`/categorias/${item.slug}`}
                        className={dropdownItem}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>

                  {/* 👶 NIÑOS + MAYORES */}
                  <div>
                    <h4 className='text-[17px] font-allround font-semibold text-[#7D744F] mb-4'>
                      Niños
                    </h4>

                    {grupos.ninos.map(item => (
                      <Link
                        key={item.id}
                        href={`/categorias/${item.slug}`}
                        className={dropdownItem}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <Link href='/libros-montessori' className={linkBase}>
              libros
            </Link>
          </li>
          <li>
            <Link href='/sets-de-regalo' className={linkBase}>
              sets de regalo
            </Link>
          </li>

          {/* LINKS NORMALES */}
          <li>
            <Link href='/catalogo-educadores' className={linkBase}>
              centros educativos
            </Link>
          </li>

          <li>
            <Link href='/nosotros' className={linkBase}>
              nosotros
            </Link>
          </li>

          <li>
            <Link href='/notas-kuma' className={linkBase}>
              notas kuma
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}
